<template>
  <div v-show="styles_loaded" :class="setbrandid" :style="new_style_variables">
    <Header
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="0"
      :logo_image="logo_image"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
      :highlight_tab_item="'FAQs'"
    ></Header>

    <div class="page-bg">
      <div class="confirmation-banner-container">
        <ConfirmationBanner
          :headline="getrans('Weather Disruptions FAQ')"
          :subheadline="''"
          edit-label="Edit"
        >
        </ConfirmationBanner>
      </div>

      <!-- <pre>{{lang.toUpperCase()}} {{faqs_api_data}}</pre> -->
      <div class="page-container">
        <div class="page-left">
          <template v-if="setbrandid === 'NOC'">
            <div class="faq-top-section">
              <!-- <h3>{{ category.category_name }}</h3> -->
              <p>
                The following is the Ireland West Airport Knock policy with
                regards requesting refunds for cancelled bookings due to flight
                delays, cancellations or deferrals.
              </p>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Can I cancel my online pre-booking if my flight is cancelled,
                  delayed, or deferred before I arrive at the airport and enter
                  the car park?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  Yes you can cancel your online booking up to 24 hours in
                  advance of your booked time/date of arrival in the car park,
                  if you booked the 'flexible airport parking' option, by using
                  the "Manage My Account" function located in the pre-book
                  section on the Ireland West Airport Knock online parking home
                  page. You need your booking reference number and the email
                  address used to make the original booking. The credit card
                  account used to make the booking will be refunded the full
                  amount of the booking fee.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Can I cancel my online pre-booking if my outbound flight is
                  cancelled, deferred, or delayed due to current adverse weather
                  after I arrive and enter the car park at Ireland West Airport
                  Knock?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No. Unfortunately, once you have entered the car park and your
                  booking has been recognised, you cannot cancel the booking
                  online. However, if your flight is cancelled after you have
                  entered the car park you can apply for a refund by submitting
                  details of your car park booking (including reference number
                  and dates) and proof of cancelled/affected flights via email
                  to
                  <a
                    href="mailto:parking@irelandwestairport.com"
                    target="_blank"
                    >parking@irelandwestairport.com</a
                  >
                  or by post to Car Parks Admin, C/o Marketing Dept, Ireland
                  West Airport Knock, Charlestown, Co. Mayo. Please note refunds
                  will only be provided for affected flights as a result of
                  disruption at Ireland West Airport Knock. Refunds will not be
                  provided for disruption caused at other airports.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Can I change my online pre-booking if my return flight is
                  cancelled, deferred or delayed due to current adverse weather
                  while I am away and my stay in the car park is longer than my
                  pre-booked stay?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No. Unfortunately, once you have entered the car park and your
                  booking has been recognised you cannot change the booking.
                  However if your return flight is delayed due to adverse
                  weather conditions at Ireland West Airport Knock, you can
                  apply for a refund by submitting details of your booking
                  (including reference number and dates) and proof of
                  cancelled/affected flights via email to
                  <a
                    href="mailto:parking@irelandwestairport.com"
                    target="_blank"
                    >parking@irelandwestairport.com</a
                  >
                  or by post to Car Parks Admin, C/o Marketing Dept, Ireland
                  West Airport Knock, Charlestown, Co. Mayo. Please note refunds
                  will only be provided for affected flights as a result of
                  disruption at Ireland West Airport Knock. Refunds will not be
                  provided for disruption caused at other airports.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Can I apply for a refund for any unused portion of my
                  pre-booked stay if I park for a time but then leave the car
                  park without flying, I.e. my stay is shorter than my
                  pre-booked period?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No. Unfortunately, once you have entered the car park and your
                  booking has been recognised you cannot change the booking.
                  However if your return flight is delayed due to adverse
                  weather conditions at Ireland West Airport Knock, you can
                  apply for a refund by submitting details of your booking
                  (including reference number and dates) and proof of
                  cancelled/affected flights via email to
                  <a
                    href="mailto:parking@irelandwestairport.com"
                    target="_blank"
                    >parking@irelandwestairport.com</a
                  >
                  or by post to Car Parks Admin, C/o Marketing Dept, Ireland
                  West Airport Knock, Charlestown, Co. Mayo. Please note refunds
                  will only be provided for affected flights as a result of
                  disruption at Ireland West Airport Knock. Refunds will not be
                  provided for disruption caused at other airports.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  My stay in the Ireland West Airport Knock car park was
                  extended due to my flights being delayed/re-scheduled due to
                  the current weather related disruption at Ireland West Airport
                  Knock and I paid the extra charges before leaving the car
                  park. Can I submit a refund claim?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  Yes. You can apply for a refund by submitting details of your
                  booking (including reference number and dates) and proof of
                  cancelled/affected flights via email to
                  <a
                    href="mailto:parking@irelandwestairport.com"
                    target="_blank"
                    >parking@irelandwestairport.com</a
                  >
                  or by post to Car Parks Admin, C/o Marketing Dept, Ireland
                  West Airport Knock, Charlestown, Co. Mayo
                </p>
              </div>
            </div>

            <!-- accordions -->
            <!-- <template
                  v-for="question_answer in category.question_answer"
                  :key="question_answer.question"
                >
                  <div class="faq-wrapper">
                    <div class="faq-toggler" @click="toggleFaq($event)">
                      <h2>{{ question_answer.question }}</h2>
                      <i class="fas fa-chevron-right"></i>
                    </div>
                    <div class="faq-content-wrap">
                      <p v-html="question_answer.answer"></p>
                    </div>
                  </div>
                </template> -->
            <!-- accordions -->
          </template>
        </div>
      </div>
    </div>

    <Footernwi
      v-if="brandSlug === 'NWI'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
    ></Footernwi>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
    ></Footer>

    <Cookies :brandSlug="setbrandid" :translations="translations"/>
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'none'" />
    <!-- <BasetimerModel v-if="covid_test_in_basket" /> -->
  </div>
</template>

<script>
const axios = require("axios");
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import Footernwi from "../../components/FooterNWI.vue";
import ConfirmationBanner from "../../components/ConfirmationBanner.vue";
import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";

import { slide } from "../../modules/slideToggle";

const genkeys = require("rezauthlib");

import { reactive } from "vue";

import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");
import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Footernwi,
    ConfirmationBanner,
    Cookies,
    CookiesOld,
    // Basket,
    // Basetimer,
    // BasetimerModel
  },
  data() {
    return {
      faqs_api_data: [],
      styles_loaded: false,
      lang: "en",
      translations: "",
      css_data: undefined,
      results_headline: "Official airport parking",
      results_subheadline: "11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      setbrandid: "",
      currency: "",
    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles);
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    toggleFaq(e) {
      let faqtogglers = document.querySelectorAll(".faq-toggler");
      if (faqtogglers) {
        [].forEach.call(faqtogglers, function (el) {
          if (el !== e.target) {
            el.classList.remove("opened");
            slide.up(el.parentElement.querySelector(".faq-content-wrap"), 300);
          }
        });
        if (e.target.getAttribute("class").indexOf("opened") > -1) {
          slide.up(
            e.target.parentElement.querySelector(".faq-content-wrap"),
            300
          );
          e.target.classList.remove("opened");
        } else {
          slide.down(
            e.target.parentElement.querySelector(".faq-content-wrap"),
            300
          );
          e.target.classList.add("opened");
        }
      }
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        if (process.env.VUE_APP_DEFAULT_LANG_DE && JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(this.setbrandid)) {
          vm.lang = 'de';
        }
        vm.setSessionData("language", vm.lang);
      }

      console.log(vm.getSessionData("language"));
      console.log("vm.lang");

      console.log(this.lang);

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          console.log("getTranscache");
          console.log(vm.translations);
        } else {
          let trans_url =
            "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=";
          if (vm.setbrandid === "AIR") {
            trans_url =
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=";
          }

          axios.get(trans_url + vm.brandSlug).then((response) => {
            console.log("getTranscache");
            console.log(response);
            vm.translations = JSON.parse(response.request.response);
            store.setItem("tranlations", JSON.stringify(vm.translations));
          });
        }
      });
    },

    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        console.log("uidgen", uidgen);

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/brandapi/branddetailsdev.php?brandslug=" +
              this.setbrandid,
            "",
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            this.setLocalData("brand_data", response.data);
            this.setMenu(response.data);
            this.setBrandData();
          });
      }
    },
    setStyles(obj) {
      /* eslint-disable */
      if (!obj) return;
obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      if (!Array.isArray(data.brand_menu) || !data.brand_menu.length > 0) return; 
data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/gtbrnslg.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response.data.slug);
          console.log(response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;
            this.loadTranslations();
            this.getBrandData();
            this.get_faqs_api_data();
          }
        });
    },

    get_faqs_api_data() {
      axios
        .post(
          `https://devapi.rezcomm.com/faq/frontend/question/answer/list`,
          {
            brand_id: this.setbrandid,
          },
          {
            headers: {
              secret_id: `2a346aa1f6606c0dcccc3a01b032363f`,
              secret_key: `3076fb4dc9214dd29516c023767f3e5a6d70d3e84ad396d2b64e9c7ad8d04a39`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.faqs_api_data = response.data.data;
        });
    },
    async get_rez_data_k()
    {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") 
      {
        let _this = this;
        await axios.get('https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php')
        .then(response => {

        const key = 'XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn';
        const encryptedData = response.data;
        let dec = _this.decrypt_custom(key, encryptedData);
        
        encryptStorage.setItem("rez_dev_k",dec);
        
             
        })
        .then(() => {
          _this.getbranded();
        }
        )
        .catch(error => {
        console.error(error);
        });
        }
        else
        {
          this.getbranded();
        }
    },
    decrypt_custom(key, data) {
      
      const decodedData = Buffer.from(data, 'base64').toString('utf8');
        const parts = decodedData.split('::');
    
        // Extract IV
        key = Buffer.from(parts[0]);
        let iv = Buffer.from(parts[2], 'hex');
    
        // Extract encrypted data
        const encryptedData = Buffer.from(parts[1], 'base64');
    
        // Create decipher object with correct IV and key
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
    
        // Update decryption with encrypted data
        let decrypted = decipher.update(encryptedData);
    
        // Finalize the decryption
        decrypted = Buffer.concat([decrypted, decipher.final()]);
    
        return decrypted.toString('utf8');
}
  },
  created() {},
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById('loader');
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
    //this.setbrandid = "BOS";this.currency="$";
    this.get_rez_data_k();
    console.log("window.location.hostname", window.location.hostname);
    //if(this.setbrandid=="")
    // {
    //   this.setbrandid = "BOS";this.currency="$";
    //   if (window.location.hostname == "herv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "HER";this.currency="€";
    //   }
    //   if (window.location.hostname == "nwiv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "NWI";this.currency="£";
    //   }
    //   if (window.location.hostname == "rduv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "RDU";this.currency="$";
    //   }
    //   if (window.location.hostname == "bosv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "BOS";this.currency="$";
    //   }
    // }
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.confirmation-banner-container {
  height: 171px;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}

$basketWidth: "420px";
.page-container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  height: auto;
  position: relative;
  .page-time-notice {
    text-align: left;
    display: flex;
    padding: 10px 0;
    p {
      max-width: calc(100% - 120px);
      padding-right: 30px;
      line-height: 1.4;
      font-size: 18px;
      font-family: $font-family-medium;
    }
    .base-timer-wrapper {
      width: 90px;
      height: 90px;
      margin-top: 15px;
    }
    @media screen and (max-width: 500px) {
      flex-direction: column-reverse;
      text-align: center;
      width: 100%;
      p {
        max-width: 100%;
        padding-right: 0px;
        line-height: 1.4;
        font-size: 18px;
      }
      .base-timer-wrapper {
        margin: 10px auto 0;
      }
    }
  }
  .page-left {
    margin: 0 15px;
    margin-bottom: 40px;
    width: 100%;
    @media screen and (min-width: 958px) {
      // width: calc((100% - #{$basketWidth}) - 45px);
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
  .page-right {
    width: 0px;
    @media screen and (min-width: 958px) {
      display: block;
      // width: #{$basketWidth};
      min-height: 500px;
      margin-right: 8px;
    }
  }
}

.faq-top-section {
  text-align: left;
  margin: 50px 15px;
  @media screen and (min-width: 958px) {
    margin: 3rem 2rem 1rem;
  }
  p {
    color: $page-text;
    line-height: 1.5;
    font-family: $font-family-medium;
  }
  h2 {
    color: $page-titles;
    font-family: $font-family-bold;
  }
}
.faq-wrapper {
  .faq-toggler {
    color: $faq-expansion-text;
    cursor: pointer;
    user-select: none;
    h2 {
      text-align: left;
      font-size: 18px;
      flex-basis: 100%;
      font-family: $font-family-bold;
    }
    .fa-chevron-right {
      transition: 0.2s ease-in-out;
      display: block;
      width: 15px;
      height: 15px;
    }
    &.opened .fa-chevron-right {
      transform: rotate(90deg);
    }
    & > * {
      pointer-events: none;
      user-select: none;
      padding: 0;
      margin: 0;
    }
    // styles
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px;
    @media screen and (min-width: 958px) {
      padding: 15px 30px;
    }
  }
  .faq-content-wrap {
    display: none;
    padding: 0 0 30px;
    margin: 0px;
    p {
      color: $page-text;
      line-height: 1.5;
      margin: 0px;
      text-align: left;
      padding: 15px 15px 0;
      font-family: $font-family-medium;
      font-size: 16px;
      a {
        color: $page-links;
      }
      @media screen and (min-width: 958px) {
        padding: 15px 30px 0;
      }
    }
  }
  &:nth-child(even) {
    background: #efefef;
  }
  &:nth-child(odd) {
    background: #fff;
  }
}

p {
  color: $page-text;
  line-height: 1.4;
  font-size: 18px;
  a {
    color: $page-links;
    &:hover {
      color: darken($page-links, 10%);
    }
  }
}
</style>
